export type ClassValue = string | number | null | false | undefined;

/** Tiny classnames joiner — filters falsy values and joins with spaces. */
export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(" ");
}
